import { render, staticRenderFns } from "./PopupNHDB.vue?vue&type=template&id=d968b32e&scoped=true"
import script from "./PopupNHDB.vue?vue&type=script&lang=js"
export * from "./PopupNHDB.vue?vue&type=script&lang=js"
import style0 from "./PopupNHDB.vue?vue&type=style&index=0&id=d968b32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d968b32e",
  null
  
)

export default component.exports